module.exports = __webpack_public_path__ + "img/sortable-arrow.37c61cb7.svg";